import store from "@/store/store";

let navItem = [];

store.state.user.groupaccess.map(item => {
  if (item.menu_type.toUpperCase() == "parent".toUpperCase()) {
    let parent = {
      id: item.id,
      url: item.path,
      name: item.menu,
      slug: item.menu,
      icon: item.icon,
      module: item.module,
      submenu: []
    };
    navItem.push(parent);
  }
});

store.state.user.groupaccess.map(item => {
  if (item.menu_type.toUpperCase() != "parent".toUpperCase()) {
    navItem.map(parent => {
      if (parent.id == item.parent) {
        let child = {
          id: item.id,
          url: item.path,
          name: item.menu,
          slug: item.menu
        };
        parent.submenu.push(child);
      }
    });
  }
});

navItem.map(item => {
  if (item.submenu.length < 1) {
    delete item.submenu;
  }
});

export default navItem;
